/*
 * Уровень доступа человека к записи реестра доступов. Вынесено из App.tsx
 * чистой функцией, чтобы правила над уровнем (например, кто держит этап
 * проверки) проверялись тестом на настоящей семантике, а не на заглушке.
 */
import { FUNCTION_SECTION, type FunctionName } from '../functions/functions';

/** Уровень записи реестра доступов (server/src/access/registry.ts); 'none' — доступа нет. */
export type AccessLevel = 'none' | 'on' | 'view' | 'assignee';

/**
 * Неотключаемые блоки: доступны всегда, даже без назначения (правило сервера,
 * registry.ts, поле `locked`) — иначе меню на секунду мигает пустотой, пока
 * назначения ещё не пришли или их вовсе нет.
 */
const ALWAYS_ON_BLOCKS = ['block.chat', 'block.notifications', 'block.profile'];

/**
 * Администратор видит всё, но исполнителем этапа от этого не становится:
 * его уровень — просмотр.
 */
export function accessLevel(
  isAdmin: boolean,
  grants: { code: string; level: string }[],
  code: string,
): AccessLevel {
  if (isAdmin) return 'view';
  if (ALWAYS_ON_BLOCKS.includes(code)) return 'on';
  const g = grants.find((x) => x.code === code);
  return (g?.level as AccessLevel | undefined) ?? 'none';
}

/**
 * «Видит все» у функции — охват на её разделе (решение Ильи 30.09.2026):
 * финансист может видеть всех собственников, не видя весь генподряд.
 * Администратор видит всё.
 */
export function seesAllOfFunction(
  isAdmin: boolean,
  grants: { code: string; scope?: string }[],
  fn: FunctionName,
): boolean {
  return isAdmin || grants.some((g) => g.code === FUNCTION_SECTION[fn] && g.scope === 'all');
}
